<template>
  <div class="content-main">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title-index">
          <h2>% de municípios que atingiram a meta nos indicadores</h2>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="container-title-grafico">
              <h6 class="title-grafico">Indicadores do Previne Brasil.</h6>
              <h6 class="sub-title">
                % de municípios que atingiram meta. Fonte: eSUS Feedback
              </h6>
            </div>

            <apexchart
              type="line"
              height="350"
              :options="chartOptions"
              :series="chartData"
              ref="chartData"
            >
            </apexchart>
            <table class="tabela">
              <thead>
                <tr>
                  <th class="sem-borda"></th>
                  <th v-for="categoria in xaxis" :key="categoria.index">
                    {{ categoria }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(serieMunicipioEquipe, index) in arrayChartData"
                  :key="`${index} + ${serieMunicipioEquipe}`"
                >
                  <td class="titulo_td">
                    <div class="container-barrinha">
                      <span
                        class="barrinha"
                        :style="{
                          background: chartOptions.colors[index],
                        }"
                      ></span>
                    </div>
                    <span class="municipio">{{
                      serieMunicipioEquipe.name
                    }}</span>
                  </td>

                  <td
                    v-for="(serie, index) in serieMunicipioEquipe.data"
                    :key="`${index} + ${serie}`"
                  >
                    {{ serie }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h6 class="sub-title">
          * Nos quadrimestres 2021 Q2 e 2021 Q3, a vacinação foi considerada
          como meta atingida para todos os municípios do Brasil.
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'MunicipiosNaMeta',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      xaxis: null,
      arrayChartData: null,
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: '',
          align: 'center',
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#000',
          },
        },
        subtitle: {
          text: '',
          align: 'center',
          margin: 10,
          offsetX: 0,
          offsetY: 25,
          floating: false,
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#000',
          },
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],

          // type: 'category'
        },
        yaxis: {
          min: 0,
          // max: 100
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: [
          '#008FFB',
          '#ff9933',
          '#FF0000',
          '#009933',
          '#ffff00',
          '#000000',
          '#ff33cc',
        ],
      },

      chartData: [],
    }
  },
  async mounted() {
    await this.grafico()
  },
  watch: {},
  methods: {
    async grafico() {
      const informacoes = require('./arquivos/mun_meta.json')
      try {
        if (informacoes) {
          let array_xaxis = []
          let array_chart_citologico = [],
            array_chart_diabetes = [],
            array_chart_hipertencao = [],
            array_chart_hiv_sifilis = [],
            array_chart_consultas_odontologicas = [],
            array_chart_pre_natal = [],
            array_chart_vacinacao = []

          //preencher a legenda
          for (const item of informacoes) {
            array_xaxis.push(item.quadrimestre)
          }
          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of informacoes) {
              var resultado_citologico = 0
              var resultado_diabetes = 0
              var resultado_hipertensao = 0
              var resultado_hiv_sifilis = 0
              var resultado_pre_natal = 0
              var resultado_consultas_odontologicas = 0
              var resultado_vacinacao = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_citologico = item.cit
                resultado_diabetes = item.dia
                resultado_hipertensao = item.hip
                resultado_hiv_sifilis = item.hivs
                resultado_pre_natal = item.pn
                resultado_consultas_odontologicas = item.odo
                resultado_vacinacao = item.vac
                break
              } else {
                resultado_citologico = null
                resultado_diabetes = null
                resultado_hipertensao = null
                resultado_hiv_sifilis = null
                resultado_pre_natal = null
                resultado_consultas_odontologicas = null
                resultado_vacinacao = null
              }
            }
            array_chart_citologico.push(resultado_citologico)
            array_chart_diabetes.push(resultado_diabetes)
            array_chart_hipertencao.push(resultado_hipertensao)
            array_chart_hiv_sifilis.push(resultado_hiv_sifilis)
            array_chart_pre_natal.push(resultado_pre_natal)
            array_chart_consultas_odontologicas.push(
              resultado_consultas_odontologicas
            )
            array_chart_vacinacao.push(resultado_vacinacao)
          }
          this.xaxis = array_xaxis
          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis,
            },
            yaxis: {
              min: 0,
              max: 100,
            },
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'Consultas pré-natal',
              data: array_chart_pre_natal,
            },
            {
              name: 'Exames HIV Sífilis',
              data: array_chart_hiv_sifilis,
            },
            {
              name: 'Consultas odontológicas',
              data: array_chart_consultas_odontologicas,
            },
            {
              name: 'Citopatológico',
              data: array_chart_citologico,
            },
            {
              name: 'Vacinas',
              data: array_chart_vacinacao,
            },
            {
              name: 'Hipertensão',
              data: array_chart_hipertencao,
            },
            {
              name: 'Diabéticos',
              data: array_chart_diabetes,
            },
          ])
          this.arrayChartData = [
            {
              name: 'Consultas pré-natal (%)',
              data: array_chart_pre_natal,
            },
            {
              name: 'Exames HIV e Sífilis (%)',
              data: array_chart_hiv_sifilis,
            },
            {
              name: 'Consultas odontológicas (%)',
              data: array_chart_consultas_odontologicas,
            },
            {
              name: 'Citopatológico (%)',
              data: array_chart_citologico,
            },
            {
              name: 'Vacinas (%)',
              data: array_chart_vacinacao,
            },
            {
              name: 'Hipertensão (%)',
              data: array_chart_hipertencao,
            },
            {
              name: 'Diabéticos (%)',
              data: array_chart_diabetes,
            },
          ]
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style>
@media screen and (min-width: 657px) and (max-width: 807px) {
}
@media screen and (min-width: 808px) and (max-width: 1023px) {
}
@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>
<style scoped>
.box-body {
  background: white;
}
.container-title-grafico {
  font-weight: bold;
  margin: 10px 38px 29px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: unset;
  margin-top: 20px;
  margin-bottom: 15px;
}
.container-title-grafico .title-grafico {
  font-weight: bold;
}
.sub-title {
  font-weight: bold;
  margin: 10px 38px 29px 30px;
}
.section-title-index {
  padding: 0;
  margin: 0;
  border-top: 0;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 3px solid #eee;
  font-size: 18px;
  color: #000;
  font-weight: 600;
  position: relative;
}
.section-title-index::before {
  content: '';
  display: block;
  width: 50px;
  height: 3px;
  background-color: #0d98bb;
  position: absolute;
  bottom: -3px;
  left: 0;
}
/* ------------ */
.tabela {
  margin: 60px auto;
}

th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
}
td:first-child {
  border-top: unset;
  border-right: unset;
}
th:first-child {
  border-top: unset;
  border-left: unset;
}
.barrinha {
  min-width: 10px;
  height: 10px;
  display: block;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
.titulo_td {
  display: flex;
  align-items: center;
  gap: 5px;
}
thead {
  border-top: unset;
  border-left: unset;
}
.municipio {
  text-align: initial;
}
.container-barrinha {
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
